// extracted by mini-css-extract-plugin
module.exports = {"modal":"Modal__modal___1pvTG","padding":"Modal__padding___2yUHd","inner":"Modal__inner___1DbX_","overlay":"Modal__overlay___2dYey"};